<div class="dialog" *ngIf="visible">
    <div class="container m-b-4">
        <div class="row">
            <div class="col">
                <h1>{{ applicationInfo.propName }}</h1>
            </div>
            <div class="col-md-auto">
                <p><b>Status: {{ applicationInfo.status }}</b></p>
            </div>

        </div>

        <div class="row">
            <div class="col-md-4">
                <div class="valuation-heading">
                    <span class="inner-heading">Application Details</span>
                </div> 
                <p>Property Name: {{ applicationInfo.propName }}</p>
                <p>Property Contact: {{ applicationInfo.contact }}t</p>
                <p>Property Email: {{ applicationInfo.email }}</p>
            </div>

            <div class="col" *ngIf="isRejected">
                <div class="valuation-heading">
                    <div class="row">
                        <div class="col">
                            <span class="inner-heading">Reason for Rejection</span>
                        </div>
                    </div>
                </div>
                <p>{{ applicationInfo.rejection_reason }}</p>
            </div>
        </div>

        <!-- <div class="row">
            <div class="col-md-12">
                <div class="valuation-heading">
                    <span class="inner-heading">Uploaded Proposal</span>
                </div>
            </div>

            <div class="col-md-12">
                <div class="alert alert-success" role="alert">
                    <div class="row">
                        <div class="col">
                            <i class="fa fa-file" aria-hidden="true"></i> &nbsp; &nbsp; <a class="link"
                                id="proposalLink">document_url</a>
                        </div>
                        <div class="col-md-auto text-center">
                            <a class="link">View</a>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->

    </div>
</div>